import React,{useContext} from 'react';
import styles from './Leftbar.module.sass';
import cn from 'classnames';
import { Link, NavLink, withRouter } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import FriendsList from '../FriendsList';
import Friends from '../../screens/Friends';
import Chat from '../../screens/Chat';

const Leftbar = ({ children, history, location, className }) => {

	const isChat = location.pathname.includes('chat');

    return (
        <>
            <nav className={cn(styles.navContainer,className, !isChat && styles.simple)}>
                {/* <Link to='/chat'>
                    <button
                        className={cn(
                            'nav_icon',
                            pathname == '/chat' && styles.active
                        )}
                    >
                        <Diversity3Icon />
                    </button>
                </Link> */}
                {/* <Chat simple={!isChat}/> */}
                {/* <Friends simple={true} onSelected={(data) => { history.push('/chat/' + data.avatarID) }}/> */}
                {/* <FriendsList/> */}
            </nav>
            
        </>
    );
};

export default withRouter(Leftbar);
